import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// A select searched as one types. With a `url`, the options come from that JSON endpoint (`?q=`), for lists
// too long to render, such as the catalogue products: each result carries id, brand, name and reference.
export default class extends Controller {
  static values = { placeholder: String, url: String }

  connect() {
    if (this.element.tomselect) return
    // Wrap in erp-select for scoped styling
    this.element.parentElement.classList.add("erp-select")

    this.select = new TomSelect(this.element, {
      create: false,
      // The prompt belongs in the placeholder, not in the option list: an empty entry showing
      // up among the search results is noise.
      placeholder: this.placeholderValue,
      allowEmptyOption: false,
      controlInput: "<input>",
      ...(this.urlValue ? this.#remoteOptions() : {})
    })
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
      this.select = null
    }
    this.element.parentElement.classList.remove("erp-select")
  }

  #remoteOptions() {
    return {
      valueField: "value",
      labelField: "text",
      searchField: [],
      // The server already filtered: keep every result it sends
      score: () => () => 1,
      shouldLoad: query => query.trim().length >= 2,
      load: (query, callback) => this.#load(query, callback)
    }
  }

  async #load(query, callback) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)

    try {
      const response = await fetch(url, { headers: { Accept: "application/json" } })
      if (!response.ok) return callback()

      const results = await response.json()
      callback(results.map(result => ({
        value: String(result.id),
        text: [ [ result.brand, result.name ].filter(Boolean).join(" "), result.reference ].filter(Boolean).join(" · ")
      })))
    } catch (error) {
      console.warn("[searchable-select] Search failed:", error)
      callback()
    }
  }
}
